import {
    PERMISSION_BACKSTAGE_ITEMS,
    PERMISSION_MANAGER_ITEMS,
    PERMISSION_PAYMENT_ITEMS,
} from './permission-settings-config';

const ALL_DEFS = [...PERMISSION_PAYMENT_ITEMS, ...PERMISSION_MANAGER_ITEMS, ...PERMISSION_BACKSTAGE_ITEMS];

/** 权限矩阵勾选字段 key 全集（快速配置从其他岗位复制时按此列表写入） */
export const PERMISSION_ALL_KEYS = ALL_DEFS.map((d) => d.key) as readonly string[];
